var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('Sidebar'),_c('PopupNotification',{directives:[{name:"show",rawName:"v-show",value:(
                this.$store.state.isVisiblePopupNotification &&
                _vm.$route.path !== '/' &&
                _vm.$route.path !== '/desktop_plug'
            ),expression:"\n                this.$store.state.isVisiblePopupNotification &&\n                $route.path !== '/' &&\n                $route.path !== '/desktop_plug'\n            "}]}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }